(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-inquiry-review"] && !Shopify.designMode) return;
  try {
    

(() => {
 const init = (scope = document) => scope.querySelectorAll('[data-cc-inquiry]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  if (root.querySelector('.globo-formbuilder')) return;
  const fields = [...root.querySelectorAll('[data-key]:not([type=checkbox])')];
  const field = key => fields.find(x => x.dataset.key === key);
  const summary = root.querySelector('.cc-inquiry__errors');
  const status = root.querySelector('.cc-inquiry__status');
  const sales = root.querySelector('.cc-inquiry__sales');
  let continued = false;
  const routes = {Wholesale:'/pages/wholesale','Corporate gifting':'/pages/corporate-gifting',Fundraising:'/pages/fundraising','Events & weddings':'/pages/events-weddings'};
  function sync() {
   root.querySelectorAll('[data-parent]').forEach(wrap => {
    const input = wrap.querySelector('[data-key]');
    const visible = field(wrap.dataset.parent)?.value === wrap.dataset.value;
    wrap.hidden = !visible; input.disabled = !visible; input.required = visible && input.dataset.required === 'true';
    if (!visible) { input.value = ''; input.removeAttribute('aria-invalid'); root.querySelector('#'+CSS.escape(input.id+'-error')).textContent = ''; }
   });
   if (sales) { const route = routes[field('category').value]; sales.hidden = !route || continued; if (route) { const key=route.split('/').pop(); sales.querySelector('a').href = location.protocol==='file:' ? key+'.html' : '/pages/'+(['fundraising','events-weddings'].includes(key)?'contact-us':key)+'?view=cc-inquiry-'+key+'&preview_theme_id=159484870887'; } }
  }
  root.addEventListener('change',e => { if (e.target.dataset.key === 'category') continued = false; sync(); summary.hidden = true; status.textContent = ''; });
  root.querySelector('[data-continue]')?.addEventListener('click',() => { continued = true; sync(); field('message').focus(); });
  function validate(input) {
   if (input.disabled) return '';
   const value=input.value.trim();
   if (input.required && !value) return root.dataset.missing;
   if (!value) return '';
   if (!input.validity.valid) return root.dataset.invalid;
   if (input.type === 'url' && !/^https?:\/\//i.test(value)) return root.dataset.invalid;
   if (input.dataset.kind && !/^not sure yet$/i.test(value)) {
    const normalized=value.replace(/[$,]/g,'').replace(/[–—]/g,'-').trim();
    const match=normalized.match(/^(\d+(?:\.\d{1,2})?)(?:\s*-\s*(\d+(?:\.\d{1,2})?))?$/);
    if (!match) return root.dataset[input.dataset.kind];
    const low=Number(match[1]), high=Number(match[2] || match[1]);
    if (low>high || (input.dataset.kind==='estimate' && (low<1 || !Number.isInteger(low) || !Number.isInteger(high)))) return root.dataset[input.dataset.kind];
   }
   if (input.type==='date') {
    const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Chicago',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const get=t=>parts.find(p=>p.type===t).value; const today=get('year')+'-'+get('month')+'-'+get('day');
    if(value<today) return root.dataset.past;
    const event=field('event_date');
    if (event && !event.disabled && event.value && input!==event && value>event.value) return root.dataset.afterEvent;
   }
   return '';
  }
  root.querySelector('[data-check]').disabled=false;
  root.querySelector('[data-check]').addEventListener('click',() => {
   summary.replaceChildren(); status.textContent=''; const errors=[];
   fields.forEach(input => {const error=validate(input); const hint=root.querySelector('#'+CSS.escape(input.id+'-error'));hint.textContent=error;if(error){input.setAttribute('aria-invalid','true');errors.push({input,error});}else{input.removeAttribute('aria-invalid');}});
   summary.hidden=!errors.length;
   if(errors.length){const title=document.createElement('p');title.textContent=root.dataset.errors;summary.append(title);const list=document.createElement('ul');errors.forEach(({input,error})=>{const li=document.createElement('li'),a=document.createElement('a');a.href='#'+input.id;a.textContent=input.labels[0].textContent.trim()+': '+error;a.addEventListener('click',e=>{e.preventDefault();input.focus();});li.append(a);list.append(li);});summary.append(list);summary.focus();}
   else { status.textContent=root.dataset.valid; status.focus(); }
  });
  sync();
 });
 init(); document.addEventListener('shopify:section:load',e=>init(e.target));
})();


  } catch(e) { console.error(e); }
})();
})();
